/**
 * @description
 * Objeto carpavisosterPK
 */

export class CarpAvisosTerPK {
    public tipusAvisId:number;
    public identificadorTer:string;

    constructor() {}
  
}